import { render, staticRenderFns } from "./Gauge.vue?vue&type=template&id=66d054a7&scoped=true"
import script from "./Gauge.vue?vue&type=script&lang=ts"
export * from "./Gauge.vue?vue&type=script&lang=ts"
import style0 from "./Gauge.vue?vue&type=style&index=0&id=66d054a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d054a7",
  null
  
)

export default component.exports